import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { makeRequest } from '../../api/api';

// Thunk to handle API call with unique imo_number and casper_id
export const fetchCasperIdAttachments = createAsyncThunk(
  'certificate/fetchCasperIdAttachments',
  async ({ casperId, imoNumber }) => {
    const param = {
      "casper_id": casperId,
      "imo_number": imoNumber,
    };
      const request = await makeRequest( "get", `api/ems/get_casperid_attachments/?casper_id=${param.casper_id}&imo_number=${param.imo_number}` );
      const response = request.data;
      return response;
  }
);
export const deleteCasperIdAttachments = createAsyncThunk(
  'certificate/deleteCasperIdAttachments',
  async (params) => {
    let attachment
    switch (params.attachment_type) {
      case 'feedstock_poo_files':
        attachment = 'feedstock_poo_urls'
        break;
      case 'first_gathering_point_urls':
        attachment = 'first_gathering_urls'
        break;
      case 'trader_urls':
        attachment = 'trader_urls'
        break;
      case 'prod_to_bunkering_urls':
        attachment = 'prod_to_bunkering_urls'
        break;
      case 'bunkering_to_usage_urls':
        attachment = 'bunkering_to_usage_urls'
        break;
      case 'verified_emission_statement_url':
        attachment = 'verified_emission_statement_url'
        break;
      default:
        attachment = params.attachment_type;
    }
      const request = await makeRequest( "patch", `api/ems/delete_casperid_attachment/?casper_id=${params.casper_id}&imo_number=${params.imo_number}&attachment_type=${attachment}&attachment_url=${params.url}` );
      const response = request.data;
      return response;
  }
);


export const uploadDocument = createAsyncThunk(
  "certificate/uploadDocument",
  async (params) => {
    console.log(params)
    const formData = new FormData();
    params.files.forEach((file) => {
      switch (file.category) {
        case 'feedstock_poo_files':
          formData.append('feedstock_poo_files', file.file, file.file.name);
          break;
        case 'first_gathering_files':
          formData.append('first_gathering_files', file.file, file.file.name);
          break;
        case 'trader_urls':
          formData.append('trader_files', file.file, file.file.name);
          break;
        case 'prod_to_bunkering_urls':
          formData.append('prod_to_bunkering_files', file.file, file.file.name);
          break;
        case 'bunkering_to_usage_urls':
          formData.append('bunkering_to_usage_files', file.file, file.file.name);
          break;
        case 'verified_emission_statement_url':
          formData.append(
            'verified_emission_statement_file',
            file.file,
            file.file.name
          );
          break;
        default:
          console.error('Unknown file category:', file.category);
      }
    });


    const request = await makeRequest(
      "post",
      `api/ems/add_casperid_attachment/?casper_id=${params.casper_id}&imo_number=${params.imo_number}`,
      formData
    );
    return request.data.data;
  }
);



const certificateSlice = createSlice({
  name: 'certificate',
  initialState: {
    casperData: null,
    loading: false,
    error: null,
    uploadStatus: 'idle',
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCasperIdAttachments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCasperIdAttachments.fulfilled, (state, action) => {
        state.loading = false;
        state.casperData = action.payload.data;
        console.log(action.payload)
      })
      .addCase(fetchCasperIdAttachments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(uploadDocument.pending, (state) => {
        state.uploadStatus = 'pending';
      })
      .addCase(uploadDocument.fulfilled, (state, action) => {
        state.uploadStatus='done'
        console.log(state)
        console.log(action)
      })
      .addCase(uploadDocument.rejected, (state, action) => {
        state.uploadStatus = 'failed';
        console.log(state)
        console.log(action)
      });
  }
});

export default certificateSlice.reducer;
